import { render, staticRenderFns } from "./RegisterKennelForm1.vue?vue&type=template&id=224a95b2"
import script from "./RegisterKennelForm1.vue?vue&type=script&lang=ts"
export * from "./RegisterKennelForm1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports